export default [
    {
      no: 1,
      imgUrl: "images/deal1.jpg",
      place: "아트 스튜디오 플로우",
      title: "레진 컵받침 체험 2인(60분)",
    point: "서울특별시 성동구 응봉동 228-28",
    price:"60,000원",
    discount:"17%",
    pricedeal:"50,000원",
      another: "8개 남음",
    },
    {
        no: 2,
        imgUrl: "images/deal2.jpg",
        place: "아트 스튜디오 플로우",
        title: "트레이 원데이 클래스(120분)",
      point: "서울특별시 성동구 응봉동 228-28",
      price:"128,000원",
      discount:"55%",
      pricedeal:"57,000원",
        another: "8개 남음",
    },
    {
        no: 3,
        imgUrl: "images/deal3.jpg",
        place: "반지대학 홍대본점",
        title: "핸드메이드 팔찌 만들기 2인",
      point: "서울특별시 마포구 교동 407-26 4층",
      price:"40,000원",
      discount:"10%",
      pricedeal:"36,000원",
        another: "7개 남음",
    },
    {
        no: 4,
        imgUrl: "images/deal4.jpg",
        place: "아트 스튜디오 플로우",
        title: "인센스 스틱 & 홀더(90분)",
      point: "서울특별시 성동구 응봉동 228-28",
      price:"60,000원",
      discount:"17%",
      pricedeal:"50,000원",
        another: "10개 남음",
    },
  ]